var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full relative my-24"},[_c('h2',{staticClass:"text-3xl font-semibold text-center mb-16 text-gray-900 px-4 sm:px-6 md:px-8 lg:px-40"},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]),_vm._v(" "),_c('cardCarousel',{attrs:{"cards":_vm.cards}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }